/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BopDisabledFlagMode {
    UseDisabledFlag = 'USE_DISABLED_FLAG',
    IgnoreDisabledFlag = 'IGNORE_DISABLED_FLAG'
}

export function BopDisabledFlagModeFromJSON(json: any): BopDisabledFlagMode {
    return BopDisabledFlagModeFromJSONTyped(json, false);
}

export function BopDisabledFlagModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BopDisabledFlagMode {
    return json as BopDisabledFlagMode;
}

export function BopDisabledFlagModeToJSON(value?: BopDisabledFlagMode | null): any {
    return value as any;
}

